/**
 * LocalStorage-based cache manager for handling abstract-storage objects.
 * Store, expire, retrieve data quickly in a standard wrapped object instance.
 */
define('disk-storage/disk-storage',['require','exports','module','abstract-storage/abstract-storage'],function(require,exports,module){

    var $Storage = require('abstract-storage/abstract-storage');

    var 
        SEP="_",
        /**
         * StorageEntry management Abstract.
         * @type {Object}
         * @see abstract-storage
         */
        manager = $Storage,
        
        /**
         * Retrieve from localStorage using the merged namespace+SEP+key value.
         * @param  {string} fullkey [description]
         * @return {object}         StorageEntry instance or empty storage object.
         */
        getWithFullKey= function(fullkey) {
            var item,
                storable,
                str = localStorage.getItem(fullkey);

            if(!str) {
                return manager.getEmpty();
            }
            
            item =  JSON.parse(str);
            storable=manager.storable(item.key,item.value,item.expires,item.priority);
            storable.created=item.created;
            storable.expired=item.expired;
            return storable;
        };
        
    return {
        /**
         * Create a new StorageEntry instance and place it in the browsers
         * localStorage cache. 
         * 
         * @param  {string} namespace Top-level container for object grouping.
         * @param  {string} key       Primary storage key for individial objects.
         * @param  {mixed}  value     Data to be stored.
         * @param  {number} expires   Time in seconds
         * @param  {number} priority  [description]
         * @return {object}           Returns a valid StorageEntry instance.
         */
        put:function(namespace, key, value, expires, priority) {
            
            var item=manager.storable(key,value,expires,priority);

            if(key){
                localStorage.setItem(namespace + SEP + key, JSON.stringify(item));
                return item;
            }
            
            return manager.getEmpty();
            
        },
        /**
         * Attempt to retrieve all items in the localStorage cache under the
         * provided namespace.
         * @param  {string} namespace   Namespace to retrieve.
         * @return {object}             Collection of retrieved items or empty object.
         */
        getAll: function(namespace) {
            var dict={},
                key,
                item,
                len=localStorage.length;
            for(var i=0; i<len; i++) {
                key = localStorage.key(i);
                if(key.indexOf(namespace)==0) {
                    item = getWithFullKey(key);
                    dict[item.key]=item;
                }
            }
            return dict;
        },
        /**
         * Attempt to retrieve a storage object from the localStoage cache items.
         * If expired as dicated by the created and expires properties,
         * the object will be marked accordingly via the expired property.
         * (If none exists, return an empty expired object)
         * 
         * @param  {object} so  A storage object to be evaluated for retrieval.
         * @uses   abstract-storage.get
         * @uses   getWithFullKey
         * @see    abstract-storage.get
         * @return {object}     Object so or an "empty" storage object.
         */        
        get: function(namespace, key) {
            if(!key) {
                return manager.getEmpty();
            }
            return manager.get(getWithFullKey(namespace+SEP+key));
        },
        /**
         * Mark a storage object as expired.
         * @param {string} namespace Namespace of object to expire.
         * @param {string} key      Key of object to expire.
         * @uses  Curveball.LocalStorage.get
         * @uses  abstract-storage.expire
         */
        expire : function(namespace, key) {
            var json=this.get(namespace,key);
            manager.expire(json);
            localStorage.setItem(namespace + SEP + key, JSON.stringify(json))
        },
        /**
         * Remove object key from object namespace and the cache.
         * @param  {string} namespace Namespace of targeted object.
         * @param  {[type]} key       Key of target object.
         */
        clear: function(namespace, key) {
            localStorage.removeItem(namespace + SEP +key);
        },
        /**
         * Remove the given namespace and it's objects from the cache.
         * @param  {string} namespace [description]
         */
        clearAll:function(namespace) {
            var i=0,key;
            for(;i<localStorage.length;i++) {
                key=localStorage.key(i);
                if(!namespace || key.indexOf(namespace+SEP)==0 ){
                    localStorage.removeItem(key);
                    i--;
                }
            }
        }
    };
});
